import {
  Spinner
} from "./chunk-L2RLNVBT.mjs";
import {
  Close_default
} from "./chunk-JFT5CIYR.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/alert/Alert.tsx
import { Transition } from "@headlessui/react";
import { cva } from "class-variance-authority";
import React, { cloneElement, useEffect, useState } from "react";
import { useTimeout } from "react-use";
var alertVariants = cva("flex items-start gap-x-4 rounded p-4 my-body-sm", {
  variants: {
    variant: {
      neutral: "bg-surface-inverted text-foreground-inverted shadow-md",
      "neutral-subtle": "bg-surface-bright text-foreground",
      success: "bg-semantic-success-surface-bold text-white shadow-md",
      "success-subtle": "bg-surface-bright text-foreground",
      info: "bg-semantic-info-surface-bold text-white shadow-md",
      "info-subtle": "bg-surface-bright text-foreground",
      critical: "bg-semantic-critical-surface-bold text-white shadow-md",
      "critical-subtle": "bg-surface-bright text-foreground",
      warning: "bg-semantic-warning-surface-bold text-white shadow-md",
      "warning-subtle": "bg-surface-bright text-foreground"
    },
    fullWidth: {
      true: "w-full"
    },
    isLoading: {
      true: "items-center bg-surface text-foreground shadow-md"
    },
    isCloseable: {
      true: "gap-x-4"
    },
    isSingleLine: {
      true: "items-center"
    }
  },
  compoundVariants: [
    { isSingleLine: false, fullWidth: false, class: "max-w-sm" }
  ],
  defaultVariants: {
    variant: "neutral",
    fullWidth: false,
    isLoading: false,
    isCloseable: false,
    isSingleLine: false
  }
});
var Alert = (_a) => {
  var _b = _a, {
    title,
    children,
    className,
    variant,
    fullWidth,
    isSingleLine = false,
    isLoading,
    isCloseable,
    icon,
    action,
    onClose,
    onAction,
    durationInMs
  } = _b, props = __objRest(_b, [
    "title",
    "children",
    "className",
    "variant",
    "fullWidth",
    "isSingleLine",
    "isLoading",
    "isCloseable",
    "icon",
    "action",
    "onClose",
    "onAction",
    "durationInMs"
  ]);
  const [show, setShow] = useState(true);
  const [isReady] = useTimeout(durationInMs);
  const readyState = (durationInMs ? isReady() : false) || false;
  const styledIcon = icon ? cloneElement(icon, {
    width: 20,
    height: 20,
    className: cn(
      {
        "text-semantic-accent-foreground-bold": variant === "neutral-subtle",
        "text-semantic-success-foreground-bold": variant === "success-subtle",
        "text-semantic-info-foreground-bold": variant === "info-subtle",
        "text-semantic-critical-foreground-bold": variant === "critical-subtle",
        "text-semantic-warning-foreground-bold": variant === "warning-subtle"
      },
      icon.props.className,
      "flex-shrink-0"
    )
  }) : null;
  useEffect(() => {
    if (readyState) {
      setShow(false);
    }
  }, [readyState, setShow]);
  return /* @__PURE__ */ React.createElement(
    Transition,
    {
      appear: false,
      show,
      leave: "transition duration-300 ease-out",
      leaveFrom: "transform opacity-100",
      leaveTo: "transform opacity-0"
    },
    /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({
        role: "alert",
        className: cn(
          alertVariants({
            variant,
            fullWidth,
            isCloseable,
            className,
            isLoading,
            isSingleLine
          })
        )
      }, props),
      !isLoading && !isSingleLine && styledIcon,
      isLoading || isSingleLine ? /* @__PURE__ */ React.createElement(React.Fragment, null, isLoading && /* @__PURE__ */ React.createElement(Spinner, { className: "flex-shrink-0 text-interactive-accent-foreground-active" }), !isLoading && styledIcon, children, action && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: cn(
            "mr-2 my-label-sm",
            fullWidth ? "ml-auto" : "ml-10"
          ),
          onClick: onAction
        },
        action
      )) : /* @__PURE__ */ React.createElement("div", { className: "flex flex-col gap-y-2" }, title && /* @__PURE__ */ React.createElement("div", { className: "my-label-sm" }, title), children && /* @__PURE__ */ React.createElement(React.Fragment, null, children), action && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "mt-2 text-left text-action-secondary-foreground my-label-sm",
          onClick: onAction
        },
        action
      )),
      isCloseable && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: cn("flex-shrink-0", { "ml-auto": !isSingleLine }),
          onClick: onClose,
          title: "Close"
        },
        /* @__PURE__ */ React.createElement(Close_default, null)
      )
    )
  );
};

export {
  Alert
};
